import React, { useState } from "react";
import { Formik } from "formik";

const initialValues = {
  searchName: "",
};

export function ReportAbuseFilter({ filterValues, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };
  const [reportAbuses, setReportAbuses] = useState(initialValues);

  return (
    <>
      <Formik
        initialValues={reportAbuses}
        onSubmit={(values) => {
          applyFilter(values);
          console.log(values);
        }}
        onReset={(values) => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchName"
                  placeholder="User Name"
                  onBlur={handleBlur}
                  value={values.searchName}
                  onChange={(e) => {
                    setFieldValue("searchName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>User Name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
